/**
 * Check if we're on a marketing/public page
 * Uses a custom meta tag in the marketing layout for robust detection
 */
export function isMarketingPage(): boolean {
  if (typeof window === "undefined" || typeof document === "undefined")
    return false

  // Check for the custom meta tag set in the marketing layout
  const pageTypeMeta = document.querySelector('meta[name="page-type"]')
  return pageTypeMeta?.getAttribute("content") === "marketing"
}
